import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../cn";

/**
 * Renke Halo — um por pagina (hero). Luz ambiente amarela, nao bloco de cor.
 */
export type PropsRkHalo = HTMLAttributes<HTMLDivElement> & {
  readonly pulse?: boolean;
  readonly children: ReactNode;
};

export function Halo({ pulse = false, className, children, ...resto }: PropsRkHalo) {
  return (
    <div
      {...resto}
      className={cn("rk-halo", pulse && "rk-halo--pulse", className)}
    >
      {children}
    </div>
  );
}
